import Plugin                           from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView                       from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import dropdownIcon                     from '@ckeditor/ckeditor5-core/theme/icons/pencil.svg';
import createDropdownPlaceholderFromId  from './createplaceholder';
import selectDropdownOptions            from './selectdropdownoptions';
import addAnswer                        from './addanswer';
import removeAnswer                     from './removeanswer';

export default class InsertDropdown extends Plugin {

    init() {

        const editor        = this.editor;
        let dropdownOptions = $('#dropdown-options');
        let dropdownDom     = $('#dropdowns-opt');
        
        editor.ui.componentFactory.add( 'InsertDropdown', locale => {

            // Set new button
            const view = new ButtonView( locale );

            view.set( {
                name        : window.trans.lms.InsertDropdown,
                label       : window.trans.lms.InsertDropdown,
                icon        : dropdownIcon,
                withText    : true,
                tooltip     : true
            } );

            // Callback executed once the option is clicked.
            view.on( 'execute', () => {

                    editor.focus();

                    // Dropdown options container
                    dropdownOptions             = $('#dropdown-options');
                    dropdownDom                 = $('#dropdowns-opt');

                    // Dropdown remove button
                    let dropdownRemoveContainer = $('.dropdown-remove-container');
                    // Last added dropdown
                    let lastDropdown            = $('#dropdown-options option').length == 0 ? 1 : $('#dropdown-options option').last().data('unique-id') + 1;
                    // Dropdown name
                    let dropdownName            = 'dropdown' + lastDropdown;
                    let unitType                 = $('#unit_type').val();

                    // Insert dropdown placeholder inside ckeditor
                    editor.model.change( writer => {

                        const insertPosition = editor.model.document.selection.getFirstPosition();
                        writer.insertText( createDropdownPlaceholderFromId(lastDropdown), insertPosition);

                    } );

                    // Append new default option for dropdown
                    dropdownOptions.append('<option data-unique-id="'+lastDropdown+'" data-id="' + dropdownName + '" value="' + dropdownName + '">' + dropdownName.replace('dropdown', window.trans.lms.Dropdown +' ') + '</option>');

                    // Append new select
                    if(unitType === window.global_vars.unit_types.test) {
                        dropdownDom.append('<div id="' + dropdownName + '" class="desc dropdowns">' +
                            '<div class="answerswrap">' +
                            '<span class="error">' + window.trans.lms.EmptyRequiredField + '</span>' +
                            '<div class="input-group">' +
                            '<input type="text" name="' + dropdownName + '[]" class="form-control" placeholder="option for selected dropdown">' +
                            '<input type="hidden" name="' + dropdownName + '_answer_keys[]" value="1">' +
                            '<span class="input-group-addon" style="padding:0;"><a data-id="' + dropdownName + '" class="btn btn-link negative removeAnswer">-</a></span>' +
                            '<span class="input-group-addon" style="padding:0;"><a data-id="' + dropdownName + '" class="btn btn-primary positive addAnswer addButton" style="border-top-left-radius:0px!important;border-bottom-left-radius:0px!important; border-top-right-radius:5px!important;border-bottom-right-radius:5px!important;">+</a></span>' +
                            '</div>' +
                            '<label>' + window.trans.lms.CorrectAnswer + ' ' +
                            '<input type="radio" value="1" class="radios" data-order="1" name="correct_dropdown' + lastDropdown + '">' +
                            '</label>' +
                            '</div>' +
                            '</div>' +
                            '<input type="hidden" name="all_dropdowns[]" value="' + lastDropdown + '">');
                    } else if(unitType === window.global_vars.unit_types.feedback) {
                        dropdownDom.append('<div id="' + dropdownName + '" class="desc dropdowns">' +
                            '<div class="answerswrap">' +
                            '<span class="error">' + window.trans.lms.EmptyRequiredField + '</span>' +
                            '<div class="input-group">' +
                            '<input type="text" name="' + dropdownName + '[]" class="form-control" placeholder="option for selected dropdown">' +
                            '<input type="hidden" name="' + dropdownName + '_answer_keys[]" value="1">' +
                            '<span class="input-group-addon" style="padding:0;"><a data-id="' + dropdownName + '" class="btn btn-link negative removeAnswer">-</a></span>' +
                            '<span class="input-group-addon" style="padding:0;"><a data-id="' + dropdownName + '" class="btn btn-primary positive addAnswer addButton" style="border-top-left-radius:0px!important;border-bottom-left-radius:0px!important; border-top-right-radius:5px!important;border-bottom-right-radius:5px!important;">+</a></span>' +
                            '</div>' +
                            '<input style="display:none" type="radio" value="false" class="radios" data-order="1" name="correct_dropdown' + lastDropdown + '">' +
                            '</label>' +
                            '</div>' +
                            '</div>' +
                            '<input type="hidden" name="all_dropdowns[]" value="' + lastDropdown + '">');
                    }

                    $('#dropdown-options option').each(function(){

                        $(this).removeAttr('selected');

                    });

                    // Fill in dropdown with single default value
                    selectDropdownOptions(dropdownName);

                    dropdownRemoveContainer.show();

                    // Add answer for "+" button
                    $('.addAnswer').off().on('click', function(){

                        addAnswer(this);

                    })

                    // Remove answer event for "-" button
                    $('.removeAnswer').off().on('click', function(event){

                        removeAnswer(event.target);

                    })
    
                    $('#dropdown-options').off().on('change', function(){

                        var selected = $(this).find(':selected').val();
                        selectDropdownOptions(selected);

                    });

                    $('.selectpicker').selectpicker('refresh');

                });

            return view;

        } );

    }

}